import {
  Button,
  Box,
  Flex,
  ListItem,
  ListIcon,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  List,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Heading,
  Text,
} from "@chakra-ui/react";
import { registerAction } from "../Store";
import { useDispatch } from "react-redux";
import { CheckCircleIcon, UnlockIcon } from "@chakra-ui/icons";

const LoginForm2 = ({ nextStep, prevStep }) => {
  const plans = [
    {
      id: 1,
      title: "Starter",
      titleDiscription: "Users that plan on sending 15-20 messages per day",
      price: 35,
      count:500,
      detail: [
        {
          id: 1,
          status: true,
          item: "500 message credits",
        },
        {
          id: 2,
          status: true,
          item: "Extra credits billed @ 5.5 ¢ each",
        },
        {
          id: 3,
          status: true,
          item: "No contract",
        },
      ],
    },
    {
      id: 2,
      title: "Intermediate",
      titleDiscription: "Users that plan on sending 30-40 messages per day",
      price: 55,
      count:1000,
      detail: [
        {
          id: 1,
          status: true,
          item: "1000 message credits",
        },
        {
          id: 2,
          status: true,
          item: "Extra credits bill @ 5 ¢ each",
        },
        {
          id: 3,
          status: true,
          item: "No contract",
        },
      ],
    },
    {
      id: 3,
      title: "Pro",
      titleDiscription: "Users that plan on sending 100-150 messages per day",
      price: 115,
      count:3000,
      detail: [
        {
          id: 1,
          status: true,
          item: "3000 message credits",
        },
        {
          id: 2,
          status: true,
          item: "Extra credits bill @ 4 ¢ each",
        },
        {
          id: 3,
          status: true,
          item: "No contract",
        },
      ],
    },
  ];
  const dispatch = useDispatch();
  return (
    <Box
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      w="100%"
      px="80px"
      py="20px"
    >
      <Box
        px="10px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        gap="20px"
      >
        <Box position="relative">
          <Heading fontSize="24px" textAlign="center">
            Choose a plan for after your trial
          </Heading>
          <Text color="gray.500" textAlign="center"  fontSize="14px">
            Your trial is totally free and lasts for 10 days after you sign up.
            If you decide to cancel before the 10 days are up you won't be charged
            anything.
          </Text>
        </Box>
        <Box
          display={{ base: "none", lg: "flex" }}
          alignItems="center"
          gap="10px"
        >
          {plans &&
            plans.map((plan) => (
              <Card
                key={plan.id}
                px="5px"
                py="5px"
                bg="white"
                shadow="xl"
                color="black"
                rounded="20px"
                cursor="pointer"
                transition="all"
                transitionDuration="0.7s"
                _hover={{ transform: "scale(1.02)", shadow: "dark-lg" }}
              >
                <CardHeader>
                  <Box fontSize="18px" fontWeight="600">
                    {plan.title}
                  </Box>
                  {/* <Box color="gray.500" fontSize="14px">
                    {plan.titleDiscription}
                  </Box> */}
                </CardHeader>

                <CardBody py="0">
                  <Box>
                    $
                    <span style={{ fontSize: "22px", fontWeight: "600" }}>
                      {plan.price}
                    </span>
                    /mo
                  </Box>
                  <List pl="0px" fontSize="14px" spacing={3}>
                    {plan.detail &&
                      plan.detail.map((item) => (
                        <ListItem key={item.id} whiteSpace="nowrap">
                          <ListIcon
                            as={item.status ? CheckCircleIcon : UnlockIcon}
                            color={item.status ? "green.500" : "red"}
                          />
                          {item.item}
                        </ListItem>
                      ))}
                  </List>
                </CardBody>
                <CardFooter>
                  <Button
                    variant="outline"
                    w="100%"
                    colorScheme="blue"
                    onClick={() => {
                      dispatch(
                        registerAction.addPlan({
                          name: plan.title,
                          price: plan.price,
                          count: plan.count
                        })
                      );
                      nextStep();
                    }}
                  >
                    Get Started
                  </Button>
                </CardFooter>
              </Card>
            ))}
        </Box>
        {/* //second Option */}
        <Box display={{ base: "block", lg: "none" }}>
          <Box p="20px" mb="15px">
            <Box textAlign="center">&laquo;</Box>
          </Box>
          <Tabs variant="line" isFitted colorScheme="blue">
            <TabList>
              {plans &&
                plans.map((plan) => (
                  <Tab key={plan.id} fontWeight="500" fontSize="14px">
                    {plan.title}
                  </Tab>
                ))}
              <Tab fontWeight="500" fontSize="14px">
                Need a custom plan not listed above?
              </Tab>
            </TabList>

            <TabPanels mt="20px">
              {plans &&
                plans.map((plan) => (
                  <TabPanel key={plan.id}>
                    <Card
                      px="15px"
                      py="15px"
                      bg="white"
                      shadow="xl"
                      color="black"
                      rounded="20px"
                      cursor="pointer"
                      transition="all"
                      transitionDuration="0.7s"
                      _hover={{ transform: "scale(1.02)", shadow: "dark-lg" }}
                    >
                      <CardHeader>
                        <Box fontSize="20px" fontWeight="600">
                          {plan.title}
                        </Box>
                        <Box color="gray.500" fontSize="14px">
                          {plan.titleDiscription}
                        </Box>
                      </CardHeader>

                      <CardBody>
                        <Box mb="10px">
                          $
                          <span style={{ fontSize: "24px", fontWeight: "600" }}>
                            {plan.price}
                          </span>
                          /mo
                        </Box>
                        <List pl="0px" spacing={3}>
                          {plan.detail &&
                            plan.detail.map((item) => (
                              <ListItem key={item.id} whiteSpace="nowrap">
                                <ListIcon
                                  as={
                                    item.status ? CheckCircleIcon : UnlockIcon
                                  }
                                  color={item.status ? "green.500" : "red"}
                                />
                                {item.item}
                              </ListItem>
                            ))}
                        </List>
                      </CardBody>
                      <CardFooter>
                        <Button
                          variant="outline"
                          w="100%"
                          colorScheme="blue"
                          onClick={() => {
                            dispatch(
                              registerAction.addPlan({
                                name: plan.title,
                                price: plan.price,
                              })
                            );
                            nextStep();
                          }}
                        >
                          Get Started
                        </Button>
                      </CardFooter>
                    </Card>
                  </TabPanel>
                ))}
              <TabPanel>
                <Card rounded="20px" w="100%" shadow="lg" p="10px">
                  <CardHeader>
                    <Box fontSize="20px" fontWeight="600">
                      Custom Plan
                    </Box>
                  </CardHeader>
                  <CardFooter>
                    <Box>
                      <Flex>
                        <Box fontWeight="600">
                          Send us an email at <a href="#">info@getinca.com</a>
                        </Box>
                        {/* <Box color="gray.600">test@test.com</Box> */}
                      </Flex>
                      {/* <Flex>
                        <Box fontWeight="600">Outlook:</Box>
                        <Box color="gray.600">test@test.com</Box>
                      </Flex> */}
                    </Box>
                  </CardFooter>
                </Card>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>

        <Button
          w="90%"
          onClick={prevStep}
          bg="#576CD1"
          color="white"
          _hover={{ bg: "#576CD1" }}
        >
          Previous
        </Button>

        <Card
          display={{ base: "none", lg: "flex" }}
          rounded="20px"
          w="90%"
          shadow="lg"
          boxShadow="xl"
          border="1px solid black"
          px="10px"
        >
          <CardHeader>
            <Box fontSize="20px" fontWeight="600">
              Need a custom plan not listed above?
            </Box>
            <Box>
              <Flex>
                <Box>
                  Send us an email at{" "}
                  <a href="mailto:info@getinca.com" style={{ color: "blue" }}>
                    info@getinca.com
                  </a>
                </Box>
              </Flex>
            </Box>
          </CardHeader>
        </Card>
      </Box>
    </Box>
  );
};

export default LoginForm2;
